// import React from 'react';
// import { FaRegCheckCircle } from 'react-icons/fa';
// import Button from '@mui/material/Button';
// import { Link } from 'react-router-dom';

// const FgtPswdChangeSuccessPg = () => {
//   return (
//     <div
//     className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
//     style={{
//       background:
//         "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
//       backgroundColor: "rgb(23,39,92)",
//     }}
//   >
//       <div className='sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2'></div>

//       <div className='sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative' style={{ borderColor: '#214471' }}>
//         <div className='w-full flex justify-center items-center'>
//           <div className='absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center'>
//             <FaRegCheckCircle size={120} style={{ color: 'green' }} />
//             <div className='text-center mt-8'>
//               <p className='text-xl font-semibold mb-3'>Password Changed!</p>
//               <p className='text-base px-10 mx-20 mb-5'>Your password has been saved successfully.</p>
//             </div>
//             <Link to='/'>
//               <Button
//                 variant='contained'
//                 color='primary'
//                 size='medium'
//                 className='mt-20'
//                 sx={{ textTransform: 'none' }}
//                 style={{
//                   color: 'white',
//                   backgroundColor: 'darkblue',
//                   fontWeight: 'bold',
//                   padding: '8px 16px',
//                   boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
//                   width: '150px'
//                 }}>
//                 Continue
//               </Button>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FgtPswdChangeSuccessPg;
import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const FgtPswdChangeSuccessPg = () => {
  return (
    <div
      className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
      style={{
        background:
          "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
        backgroundColor: "rgb(23,39,92)",
      }}
    >
      <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>
      <div
        className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative"
        style={{ borderColor: "#214471" }}
      >
          <div className="w-full flex justify-center items-center">
          <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
            {/* Success Icon */}
            <FaRegCheckCircle size={80} className="text-green-500" />

            {/* Success Message */}
            <div className="text-center mt-6">
              <p className="text-lg md:text-xl font-semibold mb-2">
                Password Changed!
              </p>
              <p className="text-sm md:text-base px-4 md:px-10">
                Your password has been saved successfully.
              </p>
            </div>

            {/* Continue Button */}
            <Link to="/">
              <Button
                variant="contained"
                color="primary"
                size="medium"
                className="mt-8"
                sx={{
                  textTransform: 'none',
                }}
                style={{
                  color: 'white',
                  backgroundColor: 'darkblue',
                  fontWeight: 'bold',
                  padding: '8px 16px',
                  marginTop:"16px",
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.2)',
                  width: '150px',
                }}
              >
                Continue
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FgtPswdChangeSuccessPg;
